var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/_user-agent.js
// module id = 207
// module chunks = 0